/**
 * Plugin: WhatsApp Não Oficial (WAHA via QR Code).
 */

import React from 'react';
import { IconBrandWhatsapp } from '@tabler/icons-react';
import { CHANNEL_CATEGORIES } from '../../types';

import useStatus from './useStatus';
import Card from './Card';
import Detail from './Detail';
import ConnectFlow from './ConnectFlow';

const WhatsAppWahaChannel = {
  id: 'whatsapp_waha',
  name: 'WhatsApp Não Oficial',
  description: 'Conexão via QR Code .',
  icon: IconBrandWhatsapp,
  color: '#25D366',
  gradient: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
  category: CHANNEL_CATEGORIES.MESSAGING,
  isAvailable: true,
  provider: 'waha',
  conflictsWith: ['whatsapp_cloud_api'],

  useStatus,

  renderCard: (agentId, context) => <Card agentId={agentId} context={context} />,
  renderDetail: (agentId, navigation) => <Detail agentId={agentId} navigation={navigation} />,
  renderConnectFlow: (agentId, onConnected, onCancel) => (
    <ConnectFlow agentId={agentId} onConnected={onConnected} onCancel={onCancel} />
  ),
};

export default WhatsAppWahaChannel;
